export enum IntegrationStatus {
    Success = 0,
    PartialSuccess = 1,
    Error = 2,
    Pending = 3,
    Cancelled = 4
}

export const integrationStatusColors: Record<IntegrationStatus, string> = {
    [IntegrationStatus.Success]: 'green',
    [IntegrationStatus.PartialSuccess]: 'gold',
    [IntegrationStatus.Error]: 'red',
    [IntegrationStatus.Pending]: 'silver',
    [IntegrationStatus.Cancelled]: 'gray'
};
